import { filter, map } from 'lodash'

import { COMPONENT_INGREDIENT_TYPES } from '../../../../common/constants'

const dishTypeAdditionalIngredientsFormInitialValues = values => ({
  id: values.id,
  definiteIngredientIds:
    map(
      filter(
        values.additionalIngredients,
        ({ type }) => type === COMPONENT_INGREDIENT_TYPES.DEFINITE,
      ),
      ({ id, name }) => ({ value: id, title: name }),
    ) || [],
  probableIngredientIds: map(
    filter(
      values.additionalIngredients,
      ({ type }) => type === COMPONENT_INGREDIENT_TYPES.PROBABLE,
    ),
    ({ id, name }) => ({ value: id, title: name }),
  ),
})

export default dishTypeAdditionalIngredientsFormInitialValues
